import { render, staticRenderFns } from "./ListLabelItem.vue?vue&type=template&id=0febb2e4&"
import script from "./ListLabelItem.vue?vue&type=script&lang=js&"
export * from "./ListLabelItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports